import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './VersionEncuestaSelector.module.css'

const VERSIONES = ['v1', 'v2', 'v3', 'v4', 'v5']

const VersionSelector = ({ className, name, label, value, onChange }) => (
  <FormControl className={`${className} ${css.main}`} variant='standard'>
    <InputLabel id={name}>{label}</InputLabel>
    <Select
      name={name}
      labelId={name}
      id={name}
      value={value}
      onChange={onChange}
      label={label}
    >
      {VERSIONES.map(version => (
        <MenuItem key={version} value={version}>
          {version}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default VersionSelector
